// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__2-zFN","header":"MessagesList_header__3LiZl","chat":"MessagesList_chat__3vGL0"};